module.exports = __webpack_public_path__ + "static/media/danone.bd782db9.png";